import { useState } from 'react';

export default function useTableToggle() {
    const [table, setTable] = useState(false);

    function handleTable(event, value) {
        event.preventDefault();
        setTable(value);
    }

    return { table, handleTable };
}
